import { render, staticRenderFns } from "./KiPilotTheorieFunctionCard.vue?vue&type=template&id=2996465b&scoped=true&"
import script from "./KiPilotTheorieFunctionCard.vue?vue&type=script&lang=ts&"
export * from "./KiPilotTheorieFunctionCard.vue?vue&type=script&lang=ts&"
import style0 from "./KiPilotTheorieFunctionCard.vue?vue&type=style&index=0&id=2996465b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2996465b",
  null
  
)

export default component.exports